export const FETCH_AVERAGE_RATING_DATA = 'FETCH_AVERAGE_RATING_DATA';
export const FETCH_USER_RATING_DATA = 'FETCH_USER_RATING_DATA';
export const FETCH_USER_UNRATED_DATA = 'FETCH_USER_UNRATED_DATA';
export const USER_GIVEN_RATING = 'USER_GIVEN_RATING';
export const ALL_RATED_PRODUCTS = 'ALL_RATED_PRODUCTS';
export const USER_FEEDBACK = 'USER_FEEDBACK';
export const FETCH_ALL_QUESTIONS = 'FETCH_ALL_QUESTIONS';
